<template>
  <vetster-collapse is-open>
    <div
      slot="header"
      class="text-xl 2xl:text-2xl font-title font-semibold text-ocean-900"
    >
      {{ $t('blogpost.why-pet-parents-love-vetster') }}
    </div>
    <div
      slot="content"
      class="vetster-prose space-y-6 mt-4"
    >
      <div class="flex flex-row space-x-4 items-center justify-start">
        <div class="bg-ocean-100 flex items-center justify-center size-16 shrink-0 rounded-xl">
          <fa
            :icon="['fal', 'video']"
            class="text-ocean-700 text-3xl"
          />
        </div>
        <div class="text-base/5 lg:text-lg/5 text-left font-medium font-title text-ocean-900">
          {{ $t('blogpost.book-online-appointments') }}
        </div>
      </div>
      <div class="flex flex-row space-x-4 items-center justify-start">
        <div class="bg-ocean-100 flex items-center justify-center size-16 shrink-0 rounded-xl">
          <fa
            :icon="['fal', 'location-dot']"
            class="text-ocean-700 text-3xl"
          />
        </div>
        <div class="text-base/5 lg:text-lg/5 text-left font-medium font-title text-ocean-900">
          {{ $t('blogpost.access-expert-pet-care') }}
        </div>
      </div>
      <div class="flex flex-row space-x-4 items-center justify-start">
        <div class="bg-ocean-100 flex items-center justify-center size-16 shrink-0 rounded-xl">
          <fa
            :icon="['fal', 'user-doctor']"
            class="text-ocean-700 text-3xl"
          />
        </div>
        <div class="text-base/5 lg:text-lg/5 text-left font-medium font-title text-ocean-900">
          {{ $t('blogpost.choose-from-licensed-veterinarians') }}
        </div>
      </div>
    </div>
  </vetster-collapse>
</template>

<script>
import VetsterCollapse from '@/components/VetsterCollapse';

export default {
  name: 'VetsterWhyVetster',

  components: { VetsterCollapse },
};
</script>
